import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import routing from "../../../../routing";
import { StaffLines } from "../../../../components/Nav/StaffLines";
import Icons from "../../../../icons";
import Icon from "../../../../icon";
import { useUser } from "../../../../store/user/selectors";

import {
    StyledNavLeft,
    MenuItem,
    Logo,
    StyledStaffLinesLeft,
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const NavLeft = ({ isPathChoir }: IProps) => {
    const { formatMessage, locale } = useIntl();
    const { loggedIn, profiled } = useUser();
    return (
        <StyledNavLeft>
            <Logo>
                <Link to={`/${routing.memory}`}>
                    <StyledStaffLinesLeft>
                        <StaffLines />
                    </StyledStaffLinesLeft>
                    <Icons.Logo slogen={formatMessage(messages.slogen)} locale={locale} />
                </Link>
            </Logo>
            {loggedIn && profiled && (
                <MenuItem active={isPathChoir} to={`/${routing.memory}/${routing.choirs}`}>
                    <Icon i="groups" />
                    <FormattedMessage {...messages.groups} />
                </MenuItem>
            )}
        </StyledNavLeft>
    );
}

export default NavLeft;
